import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type CheckMarkIconProps = Partial<SVGIconProps>;

const CheckMarkIcon: FC<CheckMarkIconProps> = (props) => (
  <SVGIcon viewBox="0 0 8 8" {...props}>
    <path
      clipRule="evenodd"
      d="M7.724 1.188a.923.923 0 0 1 .011 1.306L3.505 6.8a.923.923 0 0 1-1.317 0L.265 4.843A.923.923 0 1 1 1.582 3.55l1.264 1.287L6.418 1.2a.923.923 0 0 1 1.306-.012Z"
      fill={props?.fill ?? "currentColor"}
      fillRule="evenodd"
    />
  </SVGIcon>
);

export default CheckMarkIcon;
